var exports = {};

function qinticIn(t) {
  return t * t * t * t * t;
}

exports = qinticIn;
export default exports;